import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../../services/axiosConfig';

// As duas listas de e-mails que um ADMIN gerencia. Sao independentes: estar em uma nao concede
// nada da outra.
export const LISTAS = {
  acessoDashboard: {
    endpoint: '/api/admin/acessos-dashboard',
    titulo: 'Acesso ao Dashboard',
    descricao: 'Quem pode entrar neste dashboard e ver os dados. Nao da nenhum acesso no aplicativo.',
    inativos: 'Aguardando Aprovacao',
    nenhumInativo: 'Nenhuma solicitacao pendente.',
    ativos: 'Usuarios Aprovados',
    nenhumAtivo: 'Nenhum usuario aprovado.',
    ativar: 'Aprovar',
    rejeitar: 'Rejeitar',
    ativado: 'Usuario aprovado com sucesso!',
    exemploObservacao: 'Ex: Magistrado, Servidor...',
  },
  cortesia: {
    endpoint: '/api/admin/cortesias',
    titulo: 'Cortesia no Aplicativo',
    descricao: 'Quem ve o resultado completo no aplicativo sem assinar. Vale para a conta criada com este e-mail, depois de verificado. Nao da acesso a este dashboard.',
    inativos: 'Cortesias Desativadas',
    nenhumInativo: 'Nenhuma cortesia desativada.',
    ativos: 'Cortesias Ativas',
    nenhumAtivo: 'Nenhuma cortesia concedida.',
    ativar: 'Reativar',
    rejeitar: 'Remover',
    ativado: 'Cortesia reativada.',
    exemploObservacao: 'Ex: parceiro, teste interno...',
  },
};

const ListaDeEmailsPage = ({ lista }) => {
  const { endpoint } = lista;
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [newEmail, setNewEmail] = useState('');
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const fetchEmails = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get(endpoint);
      setEmails(response.data);
      setError('');
    } catch (err) {
      setError('Erro ao carregar lista de emails: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  useEffect(() => {
    fetchEmails();
  }, [fetchEmails]);

  const handleAddEmail = async (e) => {
    e.preventDefault();
    if (!newEmail.trim()) return;

    try {
      setSubmitting(true);
      setError('');
      await api.post(endpoint, {
        email: newEmail.trim(),
        notes: notes.trim() || null,
      });
      setNewEmail('');
      setNotes('');
      setSuccess('Email adicionado com sucesso!');
      await fetchEmails();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Erro ao adicionar email: ' + (err.response?.data?.error || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      setError('');
      await api.patch(`${endpoint}/${id}/activate`);
      setSuccess(lista.ativado);
      await fetchEmails();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Erro ao aprovar: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleReject = async (id, email) => {
    if (!window.confirm(`Rejeitar e remover ${email}?`)) {
      return;
    }
    try {
      setError('');
      await api.delete(`${endpoint}/${id}`);
      setSuccess('Usuario rejeitado.');
      await fetchEmails();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Erro ao rejeitar: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleDeactivate = async (id) => {
    try {
      setError('');
      await api.patch(`${endpoint}/${id}/deactivate`);
      await fetchEmails();
    } catch (err) {
      setError('Erro ao desativar: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleDelete = async (id, email) => {
    if (!window.confirm(`Remover permanentemente ${email}?`)) {
      return;
    }
    try {
      setError('');
      await api.delete(`${endpoint}/${id}`);
      setSuccess('Email removido.');
      await fetchEmails();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Erro ao remover: ' + (err.response?.data?.error || err.message));
    }
  };

  const pendingEmails = emails.filter((e) => !e.isActive);
  const approvedEmails = emails.filter((e) => e.isActive);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('pt-BR');
  };

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-2">{lista.titulo}</h1>
          <p className="text-muted mb-4">{lista.descricao}</p>

          {error && (
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
              {error}
              <button type="button" className="btn-close" onClick={() => setError('')}></button>
            </div>
          )}

          {success && (
            <div className="alert alert-success alert-dismissible fade show" role="alert">
              {success}
              <button type="button" className="btn-close" onClick={() => setSuccess('')}></button>
            </div>
          )}

          <div className="card mb-4 border-warning">
            <div className="card-header bg-warning text-dark d-flex justify-content-between align-items-center">
              <h5 className="mb-0">{lista.inativos} ({pendingEmails.length})</h5>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center py-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                </div>
              ) : pendingEmails.length === 0 ? (
                <div className="text-center py-3 text-muted">
                  {lista.nenhumInativo}
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead>
                      <tr>
                        <th>Email</th>
                        <th>Data da Solicitacao</th>
                        <th>Observacoes</th>
                        <th>Acoes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingEmails.map((email) => (
                        <tr key={email.id}>
                          <td><strong>{email.email}</strong></td>
                          <td>{formatDate(email.approvedAt)}</td>
                          <td><small className="text-muted">{email.notes || '-'}</small></td>
                          <td>
                            <button
                              className="btn btn-success btn-sm me-2"
                              onClick={() => handleApprove(email.id)}
                            >
                              {lista.ativar}
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => handleReject(email.id, email.email)}
                            >
                              {lista.rejeitar}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-header">
              <h5 className="mb-0">Adicionar Email Manualmente</h5>
            </div>
            <div className="card-body">
              <form onSubmit={handleAddEmail}>
                <div className="row g-3">
                  <div className="col-md-5">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                      placeholder="usuario@exemplo.com"
                      required
                    />
                  </div>
                  <div className="col-md-5">
                    <label htmlFor="notes" className="form-label">Observacoes (opcional)</label>
                    <input
                      type="text"
                      className="form-control"
                      id="notes"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      placeholder={lista.exemploObservacao}
                    />
                  </div>
                  <div className="col-md-2 d-flex align-items-end">
                    <button type="submit" className="btn btn-primary w-100" disabled={submitting}>
                      {submitting ? 'Adicionando...' : 'Adicionar'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="card">
            <div className="card-header bg-success text-white">
              <h5 className="mb-0">{lista.ativos} ({approvedEmails.length})</h5>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center py-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                </div>
              ) : approvedEmails.length === 0 ? (
                <div className="text-center py-3 text-muted">
                  {lista.nenhumAtivo}
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead>
                      <tr>
                        <th>Email</th>
                        <th>Aprovado Por</th>
                        <th>Data de Aprovacao</th>
                        <th>Observacoes</th>
                        <th>Acoes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {approvedEmails.map((email) => (
                        <tr key={email.id}>
                          <td>{email.email}</td>
                          <td>{email.approvedBy || '-'}</td>
                          <td>{formatDate(email.approvedAt)}</td>
                          <td><small className="text-muted">{email.notes || '-'}</small></td>
                          <td>
                            <div className="btn-group btn-group-sm">
                              <button
                                className="btn btn-outline-warning"
                                onClick={() => handleDeactivate(email.id)}
                                title="Revogar acesso"
                              >
                                Revogar
                              </button>
                              <button
                                className="btn btn-outline-danger"
                                onClick={() => handleDelete(email.id, email.email)}
                                title="Remover permanentemente"
                              >
                                Remover
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListaDeEmailsPage;
